import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { images } from '../../../../Constants/ImageUrls';
import {
  CarouselZoomPopup,
  CrossButton,
  NextArrow,
  PrevArrow,
  ThumbnailScrollableSec,
} from '../../PdpCarousel/styled';
import { videoExist } from '../utils';
import {
  ImageContainer,
  ImageCover,
  ImageStyle,
  RelativeDiv,
  ZoomImageContainer,
} from './styled';

function FullscreenCarousel(props) {
  const { selectedImageIndex, product, desktop } = props;
  const initialImageIndex = selectedImageIndex ? selectedImageIndex : 0;
  const [selectedImage, setSelectedImage] = useState(
    product[initialImageIndex],
  );
  const currentIndex = useRef(initialImageIndex);
  const router = useRouter();
  const thumbnailClickHandler = (index) => {
    setSelectedImage(product[index]);
    currentIndex.current = index;
  };
  const prevClickHandler = () => {
    const length = product?.length;
    let index = currentIndex.current;
    if (index < 1) {
      index = length - 1;
    } else {
      index = index - 1;
    }
    currentIndex.current = index;
    setSelectedImage(product[index]);
  };
  const nextClickHandler = () => {
    const length = product?.length;
    let index = currentIndex.current;
    if (index == length - 1) {
      index = 0;
    } else {
      index = index + 1;
    }
    currentIndex.current = index;
    setSelectedImage(product[index]);
  };

  useEffect(() => {
    document
      .getElementById(
        desktop
          ? `desktopthumb_${currentIndex.current}`
          : `thumb_${currentIndex.current}`,
      )
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
  }, [currentIndex.current]);

  const closePopupHandler = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('imageGallery');
    if (window?.history?.length > 2) {
      router.back();
    } else {
      router.replace(
        window.location.pathname.toString() + '?' + params,
        undefined,
        {
          scroll: false,
        },
      );
    }
  };
  return (
    <CarouselZoomPopup>
      <section>
        <CrossButton onClick={closePopupHandler}>&times;</CrossButton>
        <div>
          <RelativeDiv>
            <TransformWrapper
              initialPositionX={0}
              initialScale={1}
              initialPositionY={0}
              wheelStep={0.2}
              wrapperStyle={{ width: '100%' }}
            >
              {({ resetTransform }) => (
                <>
                  <PrevArrow
                    onClick={() => {
                      resetTransform();
                      prevClickHandler();
                    }}
                  >
                    <img src={images.arrow_verm} alt="" />
                  </PrevArrow>
                  <ImageContainer>
                    <TransformComponent
                      contentStyle={{ width: '100%' }}
                      wrapperStyle={{ width: '100%' }}
                    >
                      <ZoomImageContainer>
                        <img
                          style={{
                            width: '100%',
                            objectFit: 'contain',
                          }}
                          src={selectedImage}
                          alt=""
                        />
                      </ZoomImageContainer>
                    </TransformComponent>
                  </ImageContainer>
                  <NextArrow
                    onClick={() => {
                      resetTransform();
                      nextClickHandler();
                    }}
                  >
                    <img src={images.arrow_verm} alt="" />
                  </NextArrow>
                  <ThumbnailScrollableSec>
                    {product?.map((element, index) => {
                      if (!videoExist(element)) {
                        return (
                          <ImageCover
                            id={
                              desktop
                                ? `desktopthumb_${index}`
                                : `thumb_${index}`
                            }
                            key={index}
                          >
                            <ImageStyle
                              selected={
                                index === currentIndex.current ? true : null
                              }
                              onClick={() => {
                                thumbnailClickHandler(index);
                                resetTransform();
                              }}
                              src={element}
                            ></ImageStyle>
                          </ImageCover>
                        );
                      }
                    })}
                  </ThumbnailScrollableSec>
                </>
              )}
            </TransformWrapper>
          </RelativeDiv>
        </div>
      </section>
    </CarouselZoomPopup>
  );
}

export default FullscreenCarousel;
